import FullCalendar from '@fullcalendar/react';
import esLocale from '@fullcalendar/core/locales/es';
import { useContext, useMemo } from 'react';
import { TransaccionalContext } from './Transaccional';
import { confirmDialog } from 'primereact/confirmdialog';
import { useForm } from 'react-hook-form';
import { MonitoreoService } from '../../service/monitoreo/MonitoreoService';
import { useState } from 'react';
import { TablaTransaccional } from './TablaTransaccional';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useRef } from 'react';
import { Tooltip } from 'primereact/tooltip';
import '../../components/estilo.css';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialogPersonalizado } from '../../components/ConfirmDialogPersonalizado';
import { MatrizTransaccional } from '../../models/monitoreo/MatrizTransaccional';
import { useToken } from "../../components/useToken";
import { Generico } from "../../components/Generico";

export const TransaccionalCalendario = ({ permss, funcionalidades, toast, generic, plugins, initialView, tipoFechaTabla }) => {

    const monitoreoService = new MonitoreoService();
    const omodel = new MatrizTransaccional();
    const defaultValues = generic.funDefault(omodel.model);
    const { reset, setError, getValues } = useForm({ defaultValues });
    const [dialogListaTem, setDialogListaTem] = useState(false);
    const [matriz, setMatriz] = useState(null);
    const [rangoFecha, setRangoFecha] = useState({ inicio: null, fin: null });
    const [rangoVista, setRangoVista] = useState({ start: null, end: null });
    const [loading, setLoading] = useState(false);
    const [registers, setRegisters] = useState([]);
    const calendarRef = useRef(null);
    const tooltipRef = useRef(null);
    const [tablaTemporal, setTablaTemporal] = useState(true);
    const [rangoManual, setRangoManual] = useState(null);
    const [dialogSeleccionManual, setDialogSeleccionManual] = useState(false);
    const { getRol } = useToken();
    const { getContrastTextColor } = Generico();
    const { minDate, maxDate } = useMemo(() => {
        const today = new Date();
        const year = today.getFullYear();
        const minDate = new Date(year, 0, 1);   // 1 de enero
        const maxDate = new Date(year, 11, 31); // 31 de diciembre
        return { minDate, maxDate };
    }, []);

    const { nivelesRiesgo, nivelesAlerta } = useContext(TransaccionalContext);

    const cargarMonitoreos = (fechaInicio, fechaFin) => {
        setLoading(true);

        const payload = { fechaInicio, fechaFin, rol: getRol() };
        monitoreoService.consultarInfo('monitoreo/transaccional/listar-monitoreos', { lazyEvent: JSON.stringify(payload) }).then(res => {
            const baseColors = getBaseColors(nivelesRiesgo, nivelesAlerta);
            const eventosAjustados = res.data.map((evento, index) => {
                const endDate = new Date(evento.end);
                endDate.setDate(endDate.getDate() + 1);
                const color = baseColors[index % baseColors.length]; // const color = baseBlueColors[index % baseBlueColors.length]; // Si se quiere azules
                const colorTexto = getContrastTextColor(color);

                return { ...evento, end: endDate.toISOString().slice(0, 10), backgroundColor: color, borderColor: color, textColor: colorTexto };
            });
            setRegisters(eventosAjustados);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast, setError);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleCloseTabla = (seGuardo = false) => {
        setDialogListaTem(false);
        setMatriz(null);
        if (seGuardo) {
            setRegisters([]);
            cargarMonitoreos(rangoVista.start, rangoVista.end);
        }
    };

    const getBaseColors = (nivelesRiesgo, nivelesAlerta) => {
        const riesgo = nivelesRiesgo.map(n => `#${n.color_bg}`);
        const alerta = nivelesAlerta.map(n => `#${n.color_bg}`);
        return [...alerta, ...riesgo];
    };

    // Funcion que trae la información, similar a loadLazy
    const handleDatesSet = (dateInfo) => {
        const { startStr, endStr } = dateInfo;
        const start = startStr.slice(0, 10);
        const end = endStr.slice(0, 10);
        if (start !== rangoVista.start || end !== rangoVista.end) {
            setRangoVista({ start, end });
            setRegisters([]);
            cargarMonitoreos(startStr, endStr);
        }
    };

    const handleDateSelect = (selectInfo) => {
        const { startStr, start, end } = selectInfo;

        // Ajustar la fecha fin (restar 1 día porque FullCalendar da el end excluyente)
        const endDate = new Date(end);
        endDate.setDate(endDate.getDate() - 1);
        const endInclusiveStr = endDate.toISOString().slice(0, 10);

        // Guardamos las fechas seleccionadas como inclusivas
        setRangoFecha({ inicio: startStr.slice(0, 10), fin: endInclusiveStr });

        const tipoFecha = "TIP_RAN_FEC_MATRIZ_RANGO";

        const { dialogMessage, toastMessage } = mensajesMonitoreo(start, endDate);

        confirmDialog({
            group: 'confirmar-fecha',
            header: 'Confirmación',
            message: {
                texto: dialogMessage,
                tipoFecha: tipoFecha,
                fecha_inicio: startStr.slice(0, 10),
                fecha_fin: endInclusiveStr
            },
            style: { width: '30vw', borderRadius: '1rem' }
        });
    };

    const mensajesMonitoreo = (startDate, endDate) => {
        const FORMAT_OPTIONS = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
        const MS_PER_DAY = 1000 * 60 * 60 * 24;

        const fechaInicio = startDate.toLocaleDateString('es-ES', FORMAT_OPTIONS).replace(',', '');
        const fechaFin = endDate.toLocaleDateString('es-ES', FORMAT_OPTIONS).replace(',', '');

        const days = Math.round((endDate - startDate) / MS_PER_DAY);

        if (days === 0) {
            return {
                dialogMessage: `¿Está seguro de generar el monitoreo transaccional para el ${fechaInicio}?`,
                toastMessage: `Monitoreo Transaccional para el ${fechaInicio} generado con éxito.`
            };
        } else {
            return {
                dialogMessage: `¿Está seguro de generar el monitoreo transaccional desde el ${fechaInicio}, hasta el ${fechaFin}?`,
                toastMessage: `Monitoreo Transaccional desde ${fechaInicio} hasta ${fechaFin} generado con éxito.`
            };
        }
    }

    const mostrarMatriz = (data) => {
        tooltipRef.current?.hide();
        // Se toman los valores con el cual fue inicializado el evento del fullCalendar
        const endDate = data.event.endStr ? new Date(new Date(data.event.endStr).getTime() - 86400000) : null;
        const matrizSeleccionada = {
            id: data.event.id,
            nombre: data.event.extendedProps.nombre,
            observacion: data.event.extendedProps.observacion,
            codigo: data.event.title, // El codigo se le pasa como título al evento
            fecha_inicio: data.event.startStr.slice(0, 10),
            fecha_fin: endDate ? endDate.toISOString().slice(0, 10) : null,
            estado: data.event.extendedProps.estado ?? null,
            empresa: data.event.extendedProps.empresa ?? null,
        };
        setTablaTemporal(false);
        setMatriz(matrizSeleccionada);
        setDialogListaTem(true);
    }

    const formatearFechaUTC = fecha => fecha.toISOString().slice(0, 10);

    const onAceptarRango = () => {
        if (!(rangoManual?.[0] && rangoManual?.[1])) return;
        const [start, end] = rangoManual;
        const endPlusOne = new Date(end.getTime() + 24 * 60 * 60 * 1000);
        const startStr = formatearFechaUTC(start);
        const endStrPlus = formatearFechaUTC(endPlusOne);
        handleDateSelect({ start, end: endPlusOne, startStr, endStr: endStrPlus });
        setRangoManual([null, null]);
        reset();
    };

    const onSubmit = (data) => {
        data.tipo_rango_fecha = 'TIP_RAN_FEC_MATRIZ_DIA';
        data.fecha_inicio = rangoFecha.inicio;
        data.fecha_fin = rangoFecha.fin;
        if (getValues('id') == null) {
            monitoreoService.nuevo(data, 'monitoreo/transaccional/generar-temporal').then(res => {
                generic.funcSuccess(res, toast);
                setMatriz(res.data);
                setTablaTemporal(true);
                setDialogListaTem(true);
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            });
        } else {
            monitoreoService.editar(data, 'monitoreo/transaccional/editar').then(res => {
                generic.funcSuccess(res, toast);
                reset();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            });
        }
    }

    return (
        <>
            <Tooltip ref={tooltipRef} target=".tooltip-calendario" appendTo={document.body} position="bottom"
                style={{ zIndex: 9999, maxWidth: '300px', maxHeight: '300px', padding: '1rem', animation: 'fadeIn 0.3s ease-in-out' }}
            />
            <Dialog header="Seleccionar rango de fechas" visible={dialogSeleccionManual} style={{ width: '40vw', maxWidth: '600px' }} modal onHide={() => setDialogSeleccionManual(false)} className="dialog-personalizado" >
                <div className="flex flex-column gap-4 p-2">
                    <div className="flex justify-content-between gap-3 w-full items-center">
                        <Calendar locale="es" value={rangoManual?.[0] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de inicio" className="w-full" style={{ maxWidth: '35%' }} minDate={minDate} maxDate={maxDate} readOnlyInput
                            onChange={(e) => {
                                const nuevaFechaInicio = e.value;
                                const fechaFin = rangoManual?.[1];
                                const nuevaFechaFin = fechaFin && nuevaFechaInicio && nuevaFechaInicio > fechaFin ? null : fechaFin;
                                setRangoManual([nuevaFechaInicio, nuevaFechaFin]);
                            }}
                        />
                        <Calendar locale="es" value={rangoManual?.[1] || null} dateFormat="yy-mm-dd" showIcon placeholder="Fecha de fin" className="w-full" style={{ maxWidth: '35%' }} minDate={rangoManual?.[0] || minDate} maxDate={maxDate} readOnlyInput onChange={(e) => setRangoManual([rangoManual?.[0] || null, e.value])} />
                        <Button label="Aceptar" disabled={!(rangoManual?.[0] && rangoManual?.[1])} className="w-full" style={{ maxWidth: '20%', whiteSpace: 'nowrap' }}
                            onClick={() => {
                                onAceptarRango();
                                setDialogSeleccionManual(false);
                            }}
                        />
                    </div>
                </div>
            </Dialog>

            <ConfirmDialogPersonalizado group="confirmar-fecha" icon="pi pi-calendar" acceptLabel="Confirmar" rejectLabel="Cancelar"
                onAccept={(message) => {
                    const data = { tipo_rango_fecha: message.message.tipoFecha, fecha_inicio: message.message.fecha_inicio, fecha_fin: message.message.fecha_fin };
                    onSubmit(data);
                }}
            />
            <div style={{ position: 'relative', minHeight: '500px' }}>
                {loading && (
                    <div style={{ position: 'absolute', zIndex: 10, top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ProgressSpinner style={{ width: '57.5px', height: '57.5px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
                    </div>
                )}

                {!dialogListaTem && (
                    <div style={{ opacity: loading ? 0.2 : 1, pointerEvents: loading ? 'none' : 'auto', transition: 'opacity 0.3s ease' }}>
                        <FullCalendar
                            plugins={plugins}
                            initialView={initialView}
                            locales={[esLocale]}
                            locale="es"
                            headerToolbar={{
                                left: 'rangoManual',
                                center: 'title',
                                right: 'today prev,next',
                            }}
                            customButtons={{
                                rangoManual: {
                                    text: 'Rango Manual',
                                    click: () => setDialogSeleccionManual(true)
                                }
                            }}
                            selectable={!loading}
                            select={handleDateSelect}
                            datesSet={handleDatesSet}
                            events={registers}
                            ref={calendarRef}
                            eventClick={mostrarMatriz}
                            {...(plugins.some(p => p?.name === '@fullcalendar/multimonth') && { multiMonthMaxColumns: 1 })}
                            eventDidMount={(info) => {
                                const start = info.event.start;
                                const endOriginal = info.event.end;
                                // Clonar la fecha para no modificar el objeto original
                                const end = endOriginal ? new Date(endOriginal) : null;
                                if (end) end.setDate(end.getDate() - 1); // Restar 1 día
                                const tooltipText = `Inicio: ${formatearFechaUTC(start)}\nFin: ${formatearFechaUTC(end)}`;
                                info.el.classList.add('tooltip-calendario');
                                info.el.setAttribute('data-pr-tooltip', tooltipText);
                                tooltipRef.current?.updateTargetEvents();
                            }}
                            selectAllow={(selectInfo) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const start = new Date(selectInfo.start);
                                const end = new Date(selectInfo.end);
                                start.setHours(0, 0, 0, 0);
                                end.setHours(0, 0, 0, 0);
                                end.setDate(end.getDate() - 1);
                                return start <= today && end <= today;
                            }}
                        />
                    </div>
                )}

                {dialogListaTem && (
                    <TablaTransaccional tablaTemporal={tablaTemporal} matriz={matriz} tipoFecha={tipoFechaTabla} permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} handleCloseTabla={handleCloseTabla} />
                )}
            </div>
        </>
    )
}
